import { CellValue } from 'react-table';

/**
 * Aggregates columns of GapWorkIncludeWorkCellValue values into a single
 * GapWorkIncludeWorkCellValue value. We only use the first column value because we render a
 * checkbox in one of two cases:
 * - this is an aggregated row where there is exactly one sub-row
 * - this is a non-aggregated sub-row
 * This logic is enforced in the IncludeWorkCell component.
 */
export const aggregateIncludeWork = (
    columnValues: CellValue<GapWorkIncludeWorkCellValue>[],
): GapWorkIncludeWorkCellValue => columnValues[0];
